<script lang="ts" setup>
import { nextTick, onMounted, onUnmounted, ref, watch } from '#imports';
import lottie from 'lottie-web';
import unpackLottie from '~/assets/lottie/unpack-goods-bag.json';

const emit = defineEmits(['boxOpen', 'boxOpenOk', 'playSound']);
const lottieElRef = ref<HTMLDivElement>();
const lottieInstance = ref<any>(null);
const props = defineProps({
  loop: {
    type: Boolean,
    default: false,
  },
});
const onUnpacked = () => {
  destroyLottie();
  emit('boxOpenOk');
};
let playedSound = false;
const onLoopComplete = () => {
  playedSound  = false;
};

const runLottie = () => {
  destroyLottie();
  playedSound = false;
  if (!lottieElRef.value) return;
  lottieInstance.value = lottie.loadAnimation({
    container: lottieElRef.value,
    renderer: 'svg',
    loop: props.loop,
    autoplay: false, // 不自动播放
    animationData: unpackLottie,
  });
  lottieInstance.value.addEventListener('DOMLoaded', () => {
    lottieInstance.value.play();
  });
  // 在第 60 帧时执行 onUnpacked
  const onEnterFrame = (e: any) => {
    const edgeToPlaySound = 1;
    if (!playedSound && e.currentTime >= edgeToPlaySound) {
      emit('playSound');
      playedSound = true;
    }
    if (e.currentTime >= 60 && !props.loop) {
      emit('boxOpen');
      lottieInstance.value?.removeEventListener('enterFrame', onEnterFrame);
    }
  };
  lottieInstance.value.addEventListener('enterFrame', onEnterFrame);
  lottieInstance.value.addEventListener('complete', onUnpacked);
  lottieInstance.value.addEventListener('loopComplete', onLoopComplete);
};

const destroyLottie = () => {
  if (lottieInstance.value) {
    lottieInstance.value.destroy();
    lottieInstance.value = null;
  }
};

watch(
  () => props.loop,
  () => {
    if (lottieInstance.value) {
      lottieInstance.value.loop = props.loop;
    }
  },
);

onMounted(() => {
  runLottie();
});

onUnmounted(() => {
  destroyLottie();
});
</script>
<template>
  <div
    ref="lottieElRef"
    class="absolute left-1/2 top-1/2 w-[400%] -translate-x-[50%] -translate-y-[50%]"
  ></div>
</template>
<style scoped></style>
